export const SOCIAL_CONFIRMATION_URL = '/social-confirmation';
export const EMAIL_VERIFICATION_URL = '/email-verification';
export const SUCCESS_URL = '/payment-successful';
export const PAYMENT_URL = '/payment';
export const AUTH_URL = '/auth';
export const SELECT_PLAN_URL = '/select-plan';
export const BASE_URL = '/signup';

export const getUrl = (url: string) => {
    return BASE_URL + url
}
